import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { getEnvFromHostname, getUrl } from '@buffer-mono/shared-utils/bibe'

import {
  BIBE_NUMBER,
  IS_WITH_PROD,
  IS_WITH_PROD_BIBE,
  IS_WITH_STAGING,
  IS_WITH_STAGING_BIBE,
} from '~publish/env'

type PublicApiOptions = {
  hostname?: string
  withProd?: boolean
  withStaging?: boolean
  prodBibeNumber?: string
  stagingBibeNumber?: string
}

export function getPublicApiUrl({
  hostname = window.location.hostname,
  withProd = IS_WITH_PROD,
  withStaging = IS_WITH_STAGING,
  prodBibeNumber = IS_WITH_PROD_BIBE ? BIBE_NUMBER : undefined,
  stagingBibeNumber = IS_WITH_STAGING_BIBE ? BIBE_NUMBER : undefined,
}: PublicApiOptions = {}): string {
  if (withProd) return 'https://open-api.buffer.com/'
  if (withStaging) return 'https://open-api.dev.buffer.com/'
  if (prodBibeNumber)
    return `https://${prodBibeNumber}.prod-bibes.open-api.buffer.com/`
  if (stagingBibeNumber)
    return `https://${stagingBibeNumber}.staging-bibes.open-api.dev.buffer.com/`

  if (getEnvFromHostname(hostname) === 'development') {
    return 'https://free-tools-api.local.buffer.com/'
  }

  return getUrl('https://open-api.buffer.com/', hostname)
}

export const publicApiClient = new ApolloClient({
  link: new HttpLink({
    uri: getPublicApiUrl(),
    credentials: 'omit',
    headers: {
      'x-buffer-client-id': 'webapp-publishing',
      'x-buffer-client-name': 'webapp-publishing',
    },
  }),
  cache: new InMemoryCache(),
})
